module.exports = __webpack_public_path__ + "img/softIndexBlue.684c4099.png";